import { AttachMoney, Star, Favorite, Label, Savings, Email, People, Article } from '@mui/icons-material';

export const funcionalidades = [
    { icon: <AttachMoney sx={{ color: "#4FA9E2" }} />, text: "Onde você encontra descontos só para você!" },
    { icon: <Star sx={{ color: "#4FA9E2" }} />, text: "Para salvar seus cupons e usá-los a qualquer hora." },
    { icon: <Favorite sx={{ color: "#4FA9E2" }} />, text: "Para escolher suas lojas e categorias favoritas." },
    { icon: <Label sx={{ color: "#4FA9E2" }} />, text: "Fique sempre atualizado com MeuCupom Alerta" }
];

export const servicos = [
    { icon: <Savings sx={{ color: "#4FA9E2" }} />, text: "Um espaço personalizado para divulgar os descontos da sua marca." },
    { icon: <Email sx={{ color: "#4FA9E2" }} />, text: "Promover seus descontos com nossa base segmentada e atrair novos clientes." },
    { icon: <People sx={{ color: "#4FA9E2" }} />, text: "Ampliar a exposição de suas ofertas e interagir através de nossas redes sociais." },
    { icon: <Article sx={{ color: "#4FA9E2" }} />, text: "Exiba seus descontos em nosso blog e também nos artigos de nossos blogs parceiros." }
];
